// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -- Main Styles -- */

.popup-overlay {
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
}

.popup-content {
    font-size: 1rem;
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    position: relative;
    max-width: 450px;
    width: 100%;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.popup-close {
    position: absolute;
    top: 10px;
    right: 10px;
    background: transparent;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
}

.popup-close:hover {
    color: #8CBA0B;
}

.popup-title-ty {
    font-size: 1.5rem;
    color: #007E3E;
    text-align: center;
}

.popup-body {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 1rem;
    color: #333;
    text-align: center;
}

.popup-body-ty {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 1rem;
    color: #333;
    text-align: center;
    margin-bottom: 10px;
}

.popup-email {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 20px;
}

.popup-label {
    display: flex;
    align-items: center;
    padding-right: 10px; 
}

/* -- Recover Box - Input -- */

.input-email {
    position: relative;
    width: 100%;
}

.popup-input {
    color: #333;
    border: 1px solid #A1A1A1;
    border-radius: 5px;
    margin: 20px 0;
    width: 100%;
    height: 50px;
    padding-left: 10px;
}

.popup-input::placeholder {
    font-size: 0.9rem;
}

.input-email {
    display: flex;
}

.input-email i {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 20px;
    color: #4C7E43;
}

.input-error {
    border-color: red;
}

/* -- Mensagens de Erro -- */

.error-message {
    font-size: 14px;
    font-weight: bold;
    color: #FFF;
    text-align: center;
    background-color: #8B0000;
    padding: 10px;
    border-radius: 5px;
    margin: 10px 0;
    list-style-type: none;
    z-index: 10;
}`, "",{"version":3,"sources":["webpack://./src/css/sg-popup.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;IACI,eAAe;IACf,aAAa;IACb,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,8BAA8B;;AAE9B;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,4BAA4B;;AAE5B;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,WAAW;AACf","sourcesContent":["/* -- Main Styles -- */\n\n.popup-overlay {\n    position: fixed;\n    z-index: 1000;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 10px;\n}\n\n.popup-content {\n    font-size: 1rem;\n    background: #fff;\n    padding: 20px;\n    border-radius: 8px;\n    position: relative;\n    max-width: 450px;\n    width: 100%;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.popup-close {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background: transparent;\n    border: none;\n    font-size: 1.5rem;\n    cursor: pointer;\n}\n\n.popup-close:hover {\n    color: #8CBA0B;\n}\n\n.popup-title-ty {\n    font-size: 1.5rem;\n    color: #007E3E;\n    text-align: center;\n}\n\n.popup-body {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    font-size: 1rem;\n    color: #333;\n    text-align: center;\n}\n\n.popup-body-ty {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    font-size: 1rem;\n    color: #333;\n    text-align: center;\n    margin-bottom: 10px;\n}\n\n.popup-email {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    margin: 20px;\n}\n\n.popup-label {\n    display: flex;\n    align-items: center;\n    padding-right: 10px; \n}\n\n/* -- Recover Box - Input -- */\n\n.input-email {\n    position: relative;\n    width: 100%;\n}\n\n.popup-input {\n    color: #333;\n    border: 1px solid #A1A1A1;\n    border-radius: 5px;\n    margin: 20px 0;\n    width: 100%;\n    height: 50px;\n    padding-left: 10px;\n}\n\n.popup-input::placeholder {\n    font-size: 0.9rem;\n}\n\n.input-email {\n    display: flex;\n}\n\n.input-email i {\n    position: absolute;\n    right: 20px;\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 20px;\n    color: #4C7E43;\n}\n\n.input-error {\n    border-color: red;\n}\n\n/* -- Mensagens de Erro -- */\n\n.error-message {\n    font-size: 14px;\n    font-weight: bold;\n    color: #FFF;\n    text-align: center;\n    background-color: #8B0000;\n    padding: 10px;\n    border-radius: 5px;\n    margin: 10px 0;\n    list-style-type: none;\n    z-index: 10;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
